module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_682.989863cb.webp";